import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActionPlanStatusPipe } from './action-plan-status.pipe';
import { ActionStepIntervalPipe } from './action-step-interval.pipe';
import { AgePipe } from './age.pipe';
import { AppointmentStatusPipe } from './appointment-status.pipe';
import { AssessmentStatusPipe } from './assessment-status.pipe';
import { CarePlanActivityActionPipe } from './care-plan-activity-action.pipe';
import { CarePlanActivityEntityPipe } from './care-plan-activity-entity.pipe';
import { CarePlanGoalStatusPipe } from './care-plan-goal-status.pipe';
import { CarePlanStatusPipe } from './care-plan-status.pipe';
import { CharacterCountPipe } from './character-count.pipe';
import { CheckItemInArrayPipe } from './check-item-in-array.pipe';
import { CustomDatePipe } from './custom-date.pipe';
import { EnumToArrayPipe } from './enum-to-array.pipe';
import { FilterArrayPipe } from './filter-array.pipe';
import { FilterAssessmentsByStatusPipe } from './filter-assessments-by-status.pipe';
import { FilterBarriersPipe } from './filter-barriers.pipe';
import { FilterCRAsByStatusPipe } from './filter-cra-by-status.pipe';
import { FilterInterventionsPipe } from './filter-interventions.pipe';
import { FilterListAnswersPipe } from './filter-list-answers.pipe';
import { FilterNotesPipe } from './filter-notes.pipe';
import { FilterReferralsPipe } from './filter-referrals.pipe';
import { FilterSDOHActionPlansPipe } from './filter-sdoh-action-plans.pipe';
import { FilterStrengthsPipe } from './filter-strengths.pipe';
import { FilterSupportsPipe } from './filter-supports.pipe';
import { GoalTypePipe } from './goal-type.pipe';
import { InProgressSDOHActionStepCount } from './in-progress-sdoh-action-step-count.pipe';
import { InterventionStatusPipe } from './intervention-status.pipe';
import { InterventionStepTypePipe } from './intervention-step-type.pipe';
import { ListNumberPipe } from './list-number.pipe';
import { MemberDisplayIdPipe } from './member-display-id.pipe';
import { NotificationLocationPipe } from './notification-location.pipe';
import { ParenthesesPipe } from './parentheses.pipe';
import { PhoneNumberPipe } from './phone-number.pipe';
import { SafePipe } from './safe.pipe';
import { StringToArrayPipe } from './string-to-array.pipe';

@NgModule({
  declarations: [
    AgePipe,
    CheckItemInArrayPipe,
    CustomDatePipe,
    MemberDisplayIdPipe,
    EnumToArrayPipe,
    FilterBarriersPipe,
    FilterInterventionsPipe,
    FilterReferralsPipe,
    FilterNotesPipe,
    FilterStrengthsPipe,
    FilterSupportsPipe,
    ParenthesesPipe,
    PhoneNumberPipe,
    SafePipe,
    GoalTypePipe,
    CarePlanGoalStatusPipe,
    ActionStepIntervalPipe,
    InterventionStatusPipe,
    InterventionStepTypePipe,
    FilterArrayPipe,
    StringToArrayPipe,
    AppointmentStatusPipe,
    CarePlanStatusPipe,
    CarePlanActivityActionPipe,
    CarePlanActivityEntityPipe,
    ListNumberPipe,
    FilterListAnswersPipe,
    FilterAssessmentsByStatusPipe,
    FilterCRAsByStatusPipe,
    CharacterCountPipe,
    NotificationLocationPipe,
    FilterSDOHActionPlansPipe,
    InProgressSDOHActionStepCount,
    AssessmentStatusPipe,
    ActionPlanStatusPipe
  ],
  imports: [CommonModule, FormsModule],
  exports: [
    AgePipe,
    CheckItemInArrayPipe,
    CustomDatePipe,
    MemberDisplayIdPipe,
    EnumToArrayPipe,
    FilterBarriersPipe,
    FilterInterventionsPipe,
    FilterReferralsPipe,
    FilterNotesPipe,
    FilterStrengthsPipe,
    FilterSupportsPipe,
    ParenthesesPipe,
    PhoneNumberPipe,
    SafePipe,
    GoalTypePipe,
    CarePlanGoalStatusPipe,
    ActionStepIntervalPipe,
    InterventionStatusPipe,
    InterventionStepTypePipe,
    FilterArrayPipe,
    StringToArrayPipe,
    AppointmentStatusPipe,
    CarePlanStatusPipe,
    CarePlanActivityActionPipe,
    CarePlanActivityEntityPipe,
    ListNumberPipe,
    FilterListAnswersPipe,
    FilterAssessmentsByStatusPipe,
    FilterCRAsByStatusPipe,
    CharacterCountPipe,
    NotificationLocationPipe,
    FilterSDOHActionPlansPipe,
    InProgressSDOHActionStepCount,
    AssessmentStatusPipe,
    ActionPlanStatusPipe
  ]
})
export class PipesModule {}
